<!-- Navbar -->
<div class="navbar-menu flex align-items-center justify-content-between shadow-2"
    [ngStyle]="{
        'background-color': currentNavbarBackgroundColor(),
        'color': currentNavbarForegroundColor()
    }">
    <div class="flex align-items-center">
        <span class="pi pi-bars navbar-toggle-sidebar  cursor-pointer" (click)="toggleSidebar()"></span>
    </div>
    <div class="flex align-items-center">
        @if(currentUser() && currentUserHospitals()){
        <p-dropdown [(ngModel)]="currentSelectedHospital" class="hospital-dropdown" optionLabel="value"
            optionValue="key" styleClass="navbar-menu-title mr-2" dropdownIcon="fa fa-caret-down"
            [options]="currentUserHospitals()" [autoDisplayFirst]="true" (onChange)="onSelectedHospitalChange()">
            <ng-template pTemplate="selectedItem" let-hospital>
                <div class="flex align-items-center gap-2" [ngStyle]="{'color': currentNavbarForegroundColor()}">
                    <span class="fa fa-hospital-o text-lg"></span>
                    <div class="ml-1 text-base">{{ hospital.value }}</div>
                </div>
            </ng-template>
        </p-dropdown>
        } @else {
        <p-skeleton class="navbar-skeleton" height="2rem" styleClass="mr-3" width="11rem" />
        }
        <div class="navbar-menu-actions flex align-items-center">
            <div class="ml-2 mr-5">
                @if(fetchNotificationInfoLoading()){
                <p-skeleton class="navbar-skeleton" shape="circle" size="2.4rem" styleClass="mb-1" />

                } @else {
                <i class="pi pi-bell text-2xl cursor-pointer" pBadge
                    [badgeDisabled]="(notificationInfo()?.totalUnreads?.toString() ?? '0') == '0'"
                    [value]="notificationInfo()?.totalUnreads?.toString() ?? '0'"
                    (click)="showNotification(notificationPanel, $event)" pTooltip="Show unread notifications"
                    tooltipPosition="bottom"></i>
                }
            </div>


            <div class="ml-2 mr-4 mt-1 cursor-pointer navbar-menu-user-icon">
                @if(currentUser()){
                <img alt="logo" [src]="
                    currentUser() && currentUser()?.pictureUrl ?
                    currentUser()?.pictureUrl : 'assets/images/no-image.svg'" (click)="op.toggle($event)" />
                } @else {
                <p-skeleton class="navbar-skeleton" shape="circle" size="2.4rem" styleClass="mb-1" />
                }

            </div>

        </div>
    </div>
</div>

<p-overlayPanel styleClass="overlay-panel-notification" [dismissable]="true" #notificationPanel>

    <ng-template pTemplate="content">
        <div class="notification-container">
            @if(!fetchUnreadNotificationsLoading()){
                @if((unreadNotifications() && unreadNotifications().length>0)){
                    <div class="notification-contents">
                        @for (notification of unreadNotifications(); track notification.id) {
                            <div class="p-2 border-left-3 border-red-300 mb-2 shadow-1" [ngClass]="{
                                                     'bg-gray-100 border-red-300': !notification.isRead,
                                                        'bg-white border-blue-300': notification.isRead
                                                    }">
                                <div class="text-base p-1 font-semibold">
                                    {{notification.title}}
                                </div>
                                @if(notification.description){
                                <div class="p-1">
                                    {{ (notification?.description?.trim() ?? '') }}
                                </div>
                                }
                                <div class="mt-1 p-1 flex justify-content-between">
                                    <div>
                                        <span class="fa fa-check text-green-400 mr-3 text-base cursor-pointer" pTooltip="Mark as Read"
                                            tooltipPosition="bottom" (click)="markAsRead(notification)">
                                        </span>
                                        <span class="fa fa-trash text-red-400 mr-3 text-base cursor-pointer" pTooltip="Remove Notification"
                                            tooltipPosition="bottom" (click)="removeNotification(notification)">
                                        </span>
                                        @if(notification.redirectUrl){
                                            <span class="fa fa-info-circle text-blue-400 mr-3 text-base cursor-pointer" pTooltip="Show Detail"
                                                tooltipPosition="bottom" (click)="navigateToDetail(notification.redirectUrl)"></span>
                                        }
                                        @if(notification.s3FileKey &&
                                            !(notification.type?.endsWith('InProgress') || notification.type?.startsWith('Bulk'))){
                                            <span class="fa fa-download mr-3 text-base" pTooltip="Download" tooltipPosition="bottom" [ngClass]="{
                                                                    'text-purple-400': !notification.loading,
                                                                    'text-gray-400': notification.loading,
                                                                    'cursor-pointer': !notification.loading,
                                                                    'cursor-wait': notification.loading
                                                                }" (click)="getDownLoadLink(notification)">
                                            </span>
                                        }
                                    </div>
                                    <div>
                                         <span pTooltip="{{notification.updatedDateUtc|date:'yyyy-MM-dd HH:mm:ss'}}"
                                                  tooltipPosition="bottom" >
                                                <span class="text-xs">
                                                    {{ notification.updatedDateUtc| timeago }}
                                                </span>
                                         </span>
                                     </div>

                                </div>
                            </div>
                        }
                    </div>
                } @else{
                    <div class="text-gray-500 text-lg p-2 m-1 empty-notification">
                        <span class="fa fa-bell mr-1"></span> No new notifications here
                    </div>
                }
                <div class="footer mt-3 flex justify-content-between">
                    @if((unreadNotifications() && unreadNotifications().length>0)){
                        <span (click)="markAsReadAll()" class="text-green-400 mr-3 text-base cursor-pointer">
                            <span class="fa fa-check mr-1"></span> Mark as Read All
                        </span>
                    }
                    <span class="text-blue-400 text-base cursor-pointer" [routerLink]="['system','notifications']">
                        <span class="fa fa-list mr-1"></span>
                        Show All Notifications
                    </span>
                </div>
            } @else{
               <div class="text-gray-500 text-lg p-2 m-1 empty-notification">
                        Loading....
               </div>
            }


        </div>
    </ng-template>
</p-overlayPanel>

<p-overlayPanel styleClass="overlay-panel-profile" #op
    [style]="{
        'color': currentNavbarForegroundColor(),
        'background-color': currentNavbarBackgroundColor(),
        'border': '1px solid ' + currentNavbarForegroundColor()
    }">

    <ng-template pTemplate="content">
        <div style="min-width: 250px;">
            <div class="flex flex-column align-items-center">
                <img [src]="
                currentUser() && currentUser()?.pictureUrl ?
                currentUser()?.pictureUrl : 'assets/images/no-image.svg'" alt="User" class="profile-picture-overlay" />
                <div class="text-center my-3">
                    @if(currentUser()){
                        <div class="my-1 text-lg">{{ (currentUser()!.firstName + ' ' + (currentUser()!.lastName ??
                            '')).trim() }}</div>
                        <div class="mt-2 text-sm">({{ currentUser()!.email }})</div>
                        @if(currentUser()!.designation){
                            <div class="mt-2 text-sm">{{ currentUser()?.designation ?? '' }}</div>
                        }
                    }
                </div>
            </div>
            <div class="flex justify-content-between mt-2 btn-actions">
                <p-button *ngIf="allowViewProfile" icon="pi pi-user" [rounded]="true" pTooltip="Profile" tooltipPosition="right"
                    (onClick)="redirectToUserProfile()">

                </p-button>
                <!-- <p-button icon="pi pi-refresh" [rounded]="true" severity="danger"
                    pTooltip="Refresh session" tooltipPosition="left"
                    (onClick)="refreshSession()">
                 </p-button> -->
                <p-button icon="pi pi-sign-out" [rounded]="true" severity="danger" pTooltip="Sign-out"
                    tooltipPosition="left" (onClick)="logout()">
                </p-button>
            </div>
        </div>
    </ng-template>
</p-overlayPanel>


<p-confirmDialog [style]="{'min-width': '30vw'}" key="logoutConfirmDialog"></p-confirmDialog>
<p-confirmDialog [style]="{'min-width': '30vw'}" key="deleteNotificationConfirmDialog"></p-confirmDialog>
<p-confirmDialog [style]="{'min-width': '30vw'}" key="markReadConfirmDialog"></p-confirmDialog>


<p-toast key="newNotificationToast" />
